import React, { useEffect, useState, useCallback, useRef } from "react";
import logo from "../../Assets/FreeLogo.png";
// import logo from "../../Assets/boltBGew.png";
import Footer from "./footer";
import Demo_1 from "../Demo_1";
import Demo_2 from "../Demo_2";
import Demo_3 from "../Demo_3";
import Demo_4 from "../Demo_4";
import ImageCarousel from "../ImageCarousel";
import Button from "../DynamicComp/Button";
import { getData, BRAND_NAME } from "../../global/Globalapi";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart, FaHeart, FaClipboardList } from "react-icons/fa";
import LoginModal from "../Account/LoginModal";
import SignupModal from "../Account/SignupModal";
import axiosClient from '../../global/Globalapi';
import EnhancedSearchBar from "../DynamicComp/EnhancedSearchBar ";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { FiLogOut } from "react-icons/fi"

const Header1 = () => {
  // State management
  
  const [headerImage, setHeaderImage] = useState("");
  const [user, setUser] = useState(null);
  const [isSignUp, setSignUp] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [childCategories, setChildCategories] = useState({});
  const [loading, setLoading] = useState(false);
  const [mainCategories, setMainCategories] = useState([]);
  const [subChildCategories, setSubChildCategories] = useState({});
  const [bannerImages, setBannerImages] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [groupProducts, setGroupProducts] = useState([]);
  const [selectedFirstChildId, setSelectedFirstChildId] = useState(null);
  const [subCategoryImages, setSubCategoryImages] = useState([]);
  const [hoveredCategory, setHoveredCategory] = useState(null);
// const [mobileOpenParent, setMobileOpenParent] = useState(null);
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [openParent, setOpenParent] = useState(null);
const [openChild, setOpenChild] = useState(null);
const [openUserMenu, setOpenUserMenu] = useState(false);
const [allParentBanners, setAllParentBanners] = useState({});
const [selectedCategoryId, setSelectedCategoryId] = useState(null);
const [isCategorySelected, setIsCategorySelected] = useState(false);
const [avatarError, setAvatarError] = useState(false);
const userMenuRef = useRef(null);
const [offAll, setOffAll] = useState(0);
const userName =
  user?.name || user?.first_name || user?.username || user?.email?.split("@")[0] || "User";

const userImage =
  user?.picture || user?.image || user?.profile_image || user?.photoURL || "";
  const navigate = useNavigate();
  const baseURL = useRef(axiosClient.defaults.baseURL).current;

//   const fetchOffAllStatus = async () => {
//   try {
//     const res = await axiosClient.get("/api/product/off-all-status");
//     setOffAll(Number(res.data?.off_all || 0));
//   } catch (error) {
//     setOffAll(0);
//   }
// };
useEffect(() => {
  const fetchOffAllFromProducts = async () => {
    try {
      const res = await getData("/all");
      const allProducts = Array.isArray(res.data) ? res.data : [];

      const offAllValue =
        allProducts.length > 0 ? Number(allProducts[0].off_all || 0) : 0;

      setOffAll(offAllValue);
    } catch (error) {
      console.error("Failed to fetch off_all from products", error);
      setOffAll(0);
    }
  };

  fetchOffAllFromProducts();
}, []);
// useEffect(() => {
//   fetchOffAllStatus();
// }, []);

  // User authentication
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Failed to parse stored user:", error);
      }
    }
  }, []);
// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (
//       userMenuRef.current &&
//       !userMenuRef.current.contains(event.target)
//     ) {
//       setOpenUserMenu(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);

//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, []);
const desktopUserMenuRef = useRef(null);
const mobileUserMenuRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    const clickedInsideDesktop =
      desktopUserMenuRef.current?.contains(event.target);
    const clickedInsideMobile =
      mobileUserMenuRef.current?.contains(event.target);

    if (!clickedInsideDesktop && !clickedInsideMobile) {
      setOpenUserMenu(false);
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);
  // Navigation handlers
  const cartclick = () => navigate('/cart');
  const myorder = () => navigate('/myorders');
  const wishlist = () => navigate('/wishlist');
  const openModal = () => {
    setSignUp(false);
    setIsModalOpen(true);
  };

  // Handle product click from EnhancedSearchBar
  const handleProductClick = useCallback((item) => {
    try {
      let prev = [];
      try {
        const raw = localStorage.getItem('prev');
        prev = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(prev)) prev = [];
      } catch {
        prev = [];
      }

      prev.push(item.product_id);
      if (prev.length > 3) prev = prev.slice(-3);
      localStorage.setItem('prev', JSON.stringify(prev));

      navigate(`/product/${item.product_id}`);
    } catch (error) {
      console.error("Error handling product click:", error);
    }
  }, [navigate]);

  // Sign out handler
  // const handleSignOut = () => {
  //   setUser(null);
  //   localStorage.removeItem("user");
  // };
  const handleSignOut = () => {
  localStorage.removeItem("user");
  setUser(null);
  setOpenUserMenu(false); // 🔒 hide logout menu
  setMobileMenuOpen(false); // 🔒 close mobile menu if open
  navigate("/");
};

  // Enhanced category click handler
  // const handleCategoryClick = useCallback(async (category) => {
  //   try {
  //     setSelectedCategory(category);

  //     const children = childCategories[category.product_category_id] || [];
      
  //     if (children.length > 0) {
  //       setSelectedFirstChildId(children[0].product_category_id);
  //     } else {
  //       setSelectedFirstChildId(category.product_category_id);
  //     }

  //     const [bannerRes, productRes, subCategoryRes] = await Promise.all([
  //       getData(`/product_category_images/${category.product_category_id}`),
  //       getData(`/product/category/${category.product_category_id}`),
  //       getData(`/sub_category_images/${category.product_category_id}`)
  //     ]);

  //     setBannerImages(bannerRes.data || []);
  //     setGroupProducts(productRes.data || []);
  //     setSubCategoryImages(subCategoryRes.data || []);
  //   } catch (error) {
  //     console.error("Error loading category data:", error);
  //   }
  // }, [childCategories]);
//   const handleCategoryClick = useCallback(async (category) => {
//   try {
//     setIsCategorySelected(true); // ✅ USER ACTION
//     setSelectedCategory(category);

//     const children = childCategories[category.product_category_id] || [];

//     const finalId =
//       children.length > 0
//         ? children[0].product_category_id
//         : category.product_category_id;

//     setSelectedFirstChildId(finalId);

//     const [bannerRes, productRes, subCategoryRes] = await Promise.all([
//       getData(`/product_category_images/${category.product_category_id}`),
//       getData(`/product/category/${finalId}`),
//       getData(`/sub_category_images/${category.product_category_id}`)
//     ]);

//     setBannerImages(bannerRes.data || []);
//     setGroupProducts(productRes.data || []);
//     setSubCategoryImages(subCategoryRes.data || []);
//   } catch (error) {
//     console.error("Error loading category data:", error);
//   }
// }, [childCategories]);
const handleCategoryClick = useCallback(async (category) => {
  if (offAll === 1) return;

  try {
    setIsCategorySelected(true);
    setSelectedCategory(category);

    const children = childCategories[category.product_category_id] || [];

    const finalId =
      children.length > 0
        ? children[0].product_category_id
        : category.product_category_id;

    setSelectedFirstChildId(finalId);

    const [bannerRes, productRes, subCategoryRes] = await Promise.all([
      getData(`/product_category_images/${category.product_category_id}`),
      getData(`/product/category/${finalId}`),
      getData(`/sub_category_images/${category.product_category_id}`)
    ]);

    setBannerImages(bannerRes.data || []);
    setGroupProducts(productRes.data || []);
    setSubCategoryImages(subCategoryRes.data || []);
  } catch (error) {
    console.error("Error loading category data:", error);
  }
}, [childCategories, offAll]);
useEffect(() => {
  setAvatarError(false);
}, [user]);

useEffect(() => {
  document.body.style.overflow = hoveredCategory ? "hidden" : "auto";
  return () => (document.body.style.overflow = "auto");
}, [hoveredCategory]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getData("/product_category");
        
        const rootCategory = response.data.find(
          cat => cat.product_category_id === 1 || cat.parent_product_category_id === null
        );

        if (!rootCategory) {
          console.error("No root category found!");
          return;
        }

        const mains = response.data.filter(
          item => item.parent_product_category_id === rootCategory.product_category_id
        );

        setMainCategories(mains);

        const childrenMap = {};
        const subChildrenMap = {};

        mains.forEach(mainCat => {
          const children = response.data.filter(
            item => item.parent_product_category_id === mainCat.product_category_id
          );
          childrenMap[mainCat.product_category_id] = children;

          children.forEach(child => {
            const subChildren = response.data.filter(
              item => item.parent_product_category_id === child.product_category_id
            );
            subChildrenMap[child.product_category_id] = subChildren;
          });
        });

        setChildCategories(childrenMap);
        setSubChildCategories(subChildrenMap);

        if (mains.length > 0) {
          // await handleCategoryClick(mains[0]);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);
useEffect(() => {
  const fetchAllParentBanners = async () => {
    const slides = [];

    for (const parent of mainCategories) {
      try {
        const res = await getData(
          `/product_category_images/${parent.product_category_id}`
        );

        if (res.data?.length) {
          slides.push({
            category: parent,
            images: res.data
          });
        }
      } catch (err) {
        console.error("Banner fetch failed", err);
      }
    }

    setAllParentBanners(slides);
  };

  if (mainCategories.length > 0) {
    fetchAllParentBanners();
  }
}, [mainCategories]);


  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-xl">Loading categories...</div>
      </div>
    );
  }
const selectedBannerIndex =
  Array.isArray(allParentBanners) && selectedCategory
    ? allParentBanners.findIndex(
        item =>
          item.category.product_category_id ===
          selectedCategory.product_category_id
      )
    : 0;


  return (
    <div className="relative">
      {/* Header */}
      {/* ===== MOBILE HEADER ONLY ===== */}
{/* <div className="md:hidden flex items-center justify-between px-2 py-3"> */}
  <div className="md:hidden sticky top-0 z-[9999] bg-white shadow-sm
                flex items-center justify-between px-2 py-3">
  {/* Hamburger */}
  <button
    onClick={() => setMobileMenuOpen(true)}
    className="text-2xl font-bold"
  >
    ☰
  </button>

{/* Logo + Title */}
<div className="flex items-center gap-2">
  <img
    src={headerImage || logo}
    alt="Header Logo"
    className="h-10 object-contain"
  />
  <span className="text-lg font-semibold whitespace-nowrap">
    {BRAND_NAME}
  </span>
</div>

  {/* Cart / User */}
  <div className="flex items-center gap-3">
     {user && (
    <>
      {/* Orders */}
      <FaClipboardList
        size={20}
        className="cursor-pointer"
        title="My Orders"
        onClick={myorder}
      />

      {/* Cart */}
      <FaShoppingCart
        size={20}
        className="cursor-pointer"
        title="Cart"
        onClick={cartclick}
      />
      {/* Wishlist */}
      <FaHeart
        size={20}
        className="cursor-pointer text-red-500"
        title="Wishlist"
        onClick={wishlist}
      />
    </>
  )}

    {user ? (
  <div className="relative" ref={mobileUserMenuRef}>
    {/* Avatar */}

<div
  onClick={() => setOpenUserMenu(!openUserMenu)}
   title={`${userName} (${user?.email || user?.username})`}
  className="w-8 h-8 rounded-full overflow-hidden bg-blue-500 text-white
             flex items-center justify-center cursor-pointer
             font-semibold select-none"
>
  {userImage?.trim() && !avatarError ? (
    <img
      key={userImage}
      src={userImage}
      alt={userName}
      className="w-full h-full object-cover rounded-full"
      referrerPolicy="no-referrer"
      onError={(e) => {
        console.log("Avatar failed:", e.currentTarget.src);
        setAvatarError(true);
      }}
    />
  ) : (
    userName?.[0]?.toUpperCase() || "U"
  )}

</div>
    {/* MOBILE DROPDOWN */}
   
{openUserMenu && (
  <div className="absolute right-0 mt-3 w-72 bg-[#e6c9a8] text-white rounded-xl shadow-xl z-50 overflow-hidden">

    {/* PROFILE SECTION */}
    <div className="flex items-center gap-3 px-4 py-3 bg-[#e6c9a8]">

      {/* IMAGE */}
      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white">
        {userImage ? (
          <img
            src={userImage}
            alt={userName}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-white text-[#c97c5d] font-bold">
            {userName?.[0]?.toUpperCase()}
          </div>
        )}
      </div>

      {/* NAME + EMAIL */}
      <div className="flex flex-col">
        <span className="font-semibold text-sm text-black">{userName}</span>
        <span className="text-xs text-black/80 break-all">
          {user?.email || user?.username}
        </span>
      </div>
    </div>

    {/* LOGOUT */}
    <button
      onClick={() => {
        handleSignOut();
        setOpenUserMenu(false);
      }}
      className="w-full flex items-center gap-2 px-4 py-2 text-sm
               bg-[#d4a373] text-black hover:bg-[#f1d5b8] transition"
    >
       <FiLogOut className="text-lg"  />
      Logout
    </button>

  </div>
)}
  </div>
) : (
  <button
    onClick={openModal}
    className="   bg-[#c97c5d] text-white font-semibold
    px-3 py-1.5
    text-xs
    sm:px-4 sm:py-2 sm:text-sm
    md:text-base
    rounded-md
    whitespace-nowrap
  "
  >
    Sign in
  </button>
)}

  </div>
</div>

      <header className="w-full bg-[#FFFEFA] shadow-md fixed top-0 left-0 z-50">
        {/* <div className="max-w-7xl mx-auto flex items-center justify-between px-4 h-20">
          <img src={headerImage || logo} alt="Header Logo" className="h-full max-h-16 object-contain" /> */}
 {/* <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-2"> */}
 <div className="max-w-7xl mx-auto hidden md:flex items-center justify-between px-4 py-2">

          <img src={headerImage || logo} alt="Header Logo" className="h-12 object-contain" />
          <h1 className="mt-3 hidden sm:block text-xl md:text-2xl lg:text-3xl tracking-wide text-center flex-1">
           {/* Malar's Bakers */}
           {BRAND_NAME }
           
           {/* BOLT & BROOK */}
          </h1>

          <div className="flex items-center gap-4">
            {user && (
              <>
                <div className="cursor-pointer hover:text-red-600 transition-colors" onClick={myorder}>
                  <h1 className="text-sm font-medium">Orders</h1>
                </div>
                <div className="cursor-pointer hover:scale-110 transition-transform" onClick={cartclick}>
                  <FaShoppingCart size={20} color="black" title="cart"  className="cursor-pointer hover:scale-110 transition-transform" />
                </div>
                <div className="cursor-pointer hover:scale-110 transition-transform" onClick={wishlist}>
                  {/* <FaHeart size={20} color="red" /> */}
                  <FaHeart
  size={20}
  color="red"
  title="Wishlist"
  className="cursor-pointer hover:scale-110 transition-transform"
/>
                </div>
              </>
            )}

            {/* <EnhancedSearchBar 
              baseURL={baseURL}
              onProductClick={handleProductClick}
            /> */}

            {/* User Menu */}
            {/* {user ? (
              <div className="relative group">
                <img
                  src={user?.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=random&size=128`}
                  alt="User Avatar"
                  className="w-8 h-8 rounded-full cursor-pointer hover:ring-2 hover:ring-red-600 transition-all"
                />

                <div className="absolute right-0 mt-2 bg-white rounded shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all p-2">
                  <Button
                    className="px-2 py-2 w-32 bg-black text-white font-semibold rounded-md hover:bg-red-700 transition-colors"
                    onClick={user?.usertype === "guest" ? () => { localStorage.removeItem("user"); setUser(null); } : handleSignOut}
                  >
                    {user?.usertype === "guest" ? "Guest Sign Out" : "Sign Out"}
                  </Button>
                  {user?.usertype === "guest" && (
                    <Button
                      className="px-2 py-2 w-32 bg-black text-white font-semibold rounded-md hover:bg-red-700 transition-colors mt-2"
                      onClick={openModal}
                    >
                      Sign Up
                    </Button>
                  )}
                </div>
              </div>
            ) : (
              <Button
                variant="red"
                onClick={openModal}
                className="px-4 py-2 text-sm h-11 whitespace-nowrap bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              >
                Sign in
              </Button>
            )} */}
            {user ? (
  <div className="relative" ref={desktopUserMenuRef}>
    {/* Avatar */}
  
<div
  onClick={() => setOpenUserMenu(!openUserMenu)}
   title={`${userName} (${user?.email || user?.username})`}
  className="w-8 h-8 rounded-full overflow-hidden bg-blue-500 text-white
             flex items-center justify-center cursor-pointer
             font-semibold select-none"
>
  {userImage?.trim() && !avatarError ? (
    <img
      key={userImage}
      src={userImage}
      alt={userName}
      className="w-full h-full object-cover rounded-full"
      referrerPolicy="no-referrer"
      onError={(e) => {
        console.log("Avatar failed:", e.currentTarget.src);
        setAvatarError(true);
      }}
    />
  ) : (
    userName?.[0]?.toUpperCase() || "U"
  )}
</div>
    {/* Dropdown */}
   
{openUserMenu && (
  <div className="absolute right-0 mt-3 w-72 bg-[#e6c9a8] text-white rounded-xl shadow-xl z-50 overflow-hidden">

    {/* PROFILE SECTION */}
    <div className="flex items-center gap-3 px-4 py-3 ">

      {/* IMAGE */}
      <div className="w-12 h-12 rounded-full overflow-hidden bg-[#e6c9a8]  border-2 border-white">
        {userImage ? (
          <img
            src={userImage}
            alt={userName}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-white text-[#c97c5d] font-bold">
            {userName?.[0]?.toUpperCase()}
          </div>
        )}
      </div>

      {/* NAME + EMAIL */}
      <div className="flex flex-col">
        <span className="font-semibold text-sm text-black">{userName}</span>
        <span className="text-xs text-black/80 break-all">
          {user?.email || user?.username}
        </span>
      </div>
    </div>

    {/* LOGOUT */}
    <button
      onClick={() => {
        handleSignOut();
        setOpenUserMenu(false);
      }}
      className="w-full flex items-center gap-2 px-4 py-2 text-sm
                 bg-[#d4a373] text-black hover:bg-[#f1d5b8] transition"
    >
       <FiLogOut className="text-lg" />
      Logout
    </button>

  </div>
)}
  </div>
) : (
  <Button
    // variant="orange"
    onClick={openModal}
    className="px-4 py-2 text-sm h-11 bg-[#c97c5d] hover:bg-orange-300 text-white
               rounded-md "
  >
    Sign in
  </Button>
)}


          </div>
          
        </div>
      </header>
       {/* ===== MOBILE SEARCH =====
  <div className="md:hidden mt-2">
    <EnhancedSearchBar
      baseURL={baseURL}
      onProductClick={handleProductClick}
    /> */}
  {/* </div> */}
{/* ===== MOBILE MENU ===== */}
{mobileMenuOpen && (
  <div className="md:hidden fixed inset-0 bg-[#FFFEFA] z-[9999] overflow-y-auto">

    {/* ================= STICKY TOP BAR ================= */}
    <div className="flex items-center justify-between px-4 py-3
                    border-b border-gray-200
                    bg-white sticky top-0 z-10">
      <h2 className="font-semibold text-lg text-gray-800">Menu</h2>
      <button
        onClick={() => setMobileMenuOpen(false)}
        className="    absolute top-3 right-3
    flex items-center justify-center
    w-10 h-10
    text-xl
    bg-[#c97c5d] text-white
    rounded-md
    hover:bg-orange-600
    z-50
  "
      >
        ✕
      </button>
    </div>

    {/* ================= CATEGORIES ================= */}
    <div className="divide-y divide-gray-200">

      {mainCategories.map((category) => {
        const isParentOpen = openParent === category.product_category_id;
        const children = childCategories[category.product_category_id] || [];

        return (
          <div key={category.product_category_id}>

            {/* ---------- PARENT ---------- */}
            <button
              className={`w-full px-4 py-3 text-left font-semibold
  ${isParentOpen
    ? "bg-orange-50 text-orange-700"
    : "text-gray-800 hover:bg-orange-100"}`}
              onClick={() => {
                setOpenParent(
                  isParentOpen ? null : category.product_category_id
                );
                setOpenChild(null);
              }}
            >
              {category.category_name}
            </button>

            {/* ---------- CHILD ---------- */}
            {isParentOpen &&
              children.map((child) => {
                const isChildOpen =
                  openChild === child.product_category_id;

                const subCats =
                  subChildCategories[child.product_category_id] || [];

                const hasSubChildren = subCats.length > 0;

                return (
                  <div key={child.product_category_id}>

                    {/* CHILD ROW */}
                    <div className="flex items-center justify-between  px-8 py-2">

                      {/* 👉 CHILD TEXT → OPENS PRODUCTS */}
                      <span
                        onClick={() => {
                          handleCategoryClick(child);
                          setMobileMenuOpen(false);
                          setOpenParent(null);
                          setOpenChild(null);
                        }}
                        // className="text-sm text-gray-700 cursor-pointer"
                        className="text-sm text-gray-700 hover:text-orange-700 cursor-pointer"

                      >
                        {child.category_name}
                      </span>

                      {/* 👉 ARROW → OPENS SUB CHILD */}
                      {hasSubChildren && (
                        <button
                          onClick={() =>
                            setOpenChild(
                              isChildOpen
                                ? null
                                : child.product_category_id
                            )
                          }
                          // className="text-lg px-2 text-black-500"
                        className="p-0 bg-transparent border-none hover:text-orange-700 text-black text-lg leading-none"

                        >
                          {isChildOpen ? "▾" : "▸"}
                        </button>
                      )}
                    </div>

                    {/* ---------- SUB CHILD ---------- */}
                    {isChildOpen &&
                      subCats.map((subChild) => (
                        <button
                          key={subChild.product_category_id}
                          onClick={() => {
                            handleCategoryClick(subChild);
                            setMobileMenuOpen(false);
                            setOpenParent(null);
                            setOpenChild(null);
                          }}
          //                 className="block w-full px-12 py-2
          //  text-sm text-gray-400
          //  hover:bg-gray-50 hover:text-gray-600
          //  text-left"
className="block w-full px-12 py-2
           text-sm text-gray-500
           bg-orange-50/40
           hover:bg-orange-100 hover:text-orange-700
           text-left"

                        >
                          {subChild.category_name}
                        </button>
                      ))}
                  </div>
                );
              })}
          </div>
        );
      })}
    </div>
  </div>
)}


      {/* Navigation Bar */}
      {/* <nav className="w-full h-14 bg-gray-50 flex items-center justify-center fixed top-20 left-0 z-40 border-b border-t border-gray-200">

        <div className="flex h-full items-center gap-8"> */}
         {/* <nav className="w-full h-14 bg-gray-50 flex items-center justify-center fixed top-16 left-0 z-40 border-b border-t border-gray-200">
        <div className="flex items-center space-x-8 h-full"> */}
         {/* ================= NAV BAR ================= */}
{/* <nav className="fixed top-[88px] left-0 w-screen bg-gray-50 z-40 border-b border-t border-gray-200"> */}
{/* <nav className="fixed top-[88p/x] left-0 w-screen bg-gray-50 z-40 border-b border-t border-gray-200"> */}
<nav className="hidden md:block fixed top-[88px] left-0 w-screen bg-gray-50 z-40">

  {/* <div className="max-w-7xl mx-auto h-14 flex items-center gap-8 px-6 overflow-x-auto whitespace-nowrap scrollbar-hide"> */}
{/* <div className="w-full px-8 h-14 flex items-center justify-center gap-2"> */}
<div className="
  w-full h-14 flex items-center justify-center
  gap-1
  px-2
  lg:px-4
  overflow-x-auto
  whitespace-nowrap
  scrollbar-hide
">

    {mainCategories.map((category) => {
      const children = childCategories[category.product_category_id] || [];
      const hasChildren = children.length > 0;

      return (
        <div
          key={category.product_category_id}
          className="h-full flex items-center"
          onMouseEnter={() => setHoveredCategory(category.product_category_id)}
          onMouseLeave={() => setHoveredCategory(null)}
          onClick={() =>
            setHoveredCategory(
              hoveredCategory === category.product_category_id
                ? null
                : category.product_category_id
            )
          }
        >
          {/* Parent Category */}
          <div
            // className="px-3 py-2 text-sm md:text-base font-semibold uppercase
            //            cursor-pointer transition-colors
            //            text-gray-800 hover:text-blue-600"
              className="
    px-2 py-1
    text-xs
    sm:text-sm
    md:text-sm
    lg:text-base
    font-semibold uppercase
    cursor-pointer transition-colors
    text-gray-800 hover:text-orange-300 border-l border-gray-600
  "
            onClick={() => handleCategoryClick(category)}
          >
            {category.category_name}
          </div>

          {/* ================= MEGA DROPDOWN ================= */}
          {hasChildren && hoveredCategory === category.product_category_id && (
            <div
              className="fixed left-0 top-[142px] w-screen
                         bg-white z-[9999]  hover:text-orange-700
                         shadow-xl border-t border-gray-200"
            >
              <div className="max-w-7xl mx-auto px-10 py-8">

                {/* Grid like Flipkart */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">

                  {children.map((child) => {
                    const subCats =
                      subChildCategories[child.product_category_id] || [];

                    return (
                      <div key={child.product_category_id} className="space-y-4">
                      {/* <div
  key={child.product_category_id}
  className="space-y-4 pl-6 border-l border-gray-200"
> */}

                        {/* Child Heading */}
                        <h3
                          onClick={() => handleCategoryClick(child)}
                          className="text-sm font-semibold uppercase
                                     text-gray-900 cursor-pointer
                                      hover:text-orange-700"
                        >
                          {child.category_name}
                        </h3>

                        {/* Sub Children */}
                        <ul className="space-y-2 ml-8">
                          {subCats.map((subChild) => (
                            <li key={subChild.product_category_id}>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleCategoryClick(subChild);
                                  setHoveredCategory(null);
                                }}
                                className="block text-sm text-gray-600
                                           hover:text-gray-900"
                              >
                                {subChild.category_name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}

                </div>
              </div>
            </div>
          )}
          {/* ================= END MEGA DROPDOWN ================= */}
        </div>
      );
    })}
  </div>
</nav>


      {/* Modals */}
      {isModalOpen && (
        <LoginModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setSignUp={setSignUp}
          setUser={setUser}
          type={user?.usertype === "guest" ? "guest" : undefined}
        />
      )}

      {isSignUp && (
        <SignupModal
          isSignUp={isSignUp}
          setSignUp={setSignUp}
          setUser={setUser}
          type={user?.usertype === "guest" ? "guest" : undefined}
        />
      )}

      {/* Content */}
      {/* <Demo_1 bannerImages={bannerImages} selectedCategory={selectedCategory} mainCategories={mainCategories} /> */}
      {/* <ImageCarousel autoPlay={true} interval={4000} /> */}
       {/* <Demo_3 categoryId={selectedFirstChildId} /> */}
      {/* <Demo_2 subCategoryImages={subCategoryImages} selectedCategory={selectedCategory} /> */}
      {/* <Demo_3 categoryId={selectedFirstChildId} /> */}
       {/* <ImageCarousel autoPlay={true} interval={4000} /> */}
      {/* <Footer /> */}

{/* ================= HERO BANNER (ONE TIME ONLY) ================= */}
{allParentBanners.length > 0 && (
  <Carousel
    showThumbs={false}
    showStatus={false}
    infiniteLoop
    autoPlay
    interval={4000}
    stopOnHover
    swipeable
    emulateTouch
    selectedItem={selectedBannerIndex >= 0 ? selectedBannerIndex : 0}
    className="mt-[29px]"
  >
    {allParentBanners.map(slide => (
      <div key={slide.category.product_category_id}>
        <Demo_1
          bannerImages={slide.images}
          selectedCategory={slide.category}
          mainCategories={mainCategories}
        />
      </div>
    ))}
  </Carousel>
)}


{/* ================= PRODUCTS (ONE TIME ONLY) ================= */}
{/* <Demo_3 categoryId={selectedFirstChildId} /> */}
{/* <Demo_3/> */}
{/* <Demo_3 categoryId={selectedFirstChildId || null} /> */}
{/* {!isCategorySelected ? (
  // <Demo_4 />               // ✅ ALL PRODUCTS (DEFAULT)
   <>
    <Demo_3 showOnlyFeatured={true} />
    <Demo_4 />
  </>
) : (
  <Demo_3 categoryId={selectedFirstChildId} /> // ✅ CATEGORY PRODUCTS
)} */}
{offAll === 1 ? (
  <div className="w-full flex items-center justify-center py-24">
    <div className="text-center">
      <h2 className="text-3xl font-bold text-gray-800">
        Shop is currently closed
      </h2>
      <p className="text-gray-500 mt-3">
        We’re not accepting orders right now. Please check back later.
      </p>
    </div>
  </div>
) : !isCategorySelected ? (
  <>
    <Demo_3 showOnlyFeatured={true} />
    <Demo_4 />
  </>
) : (
  <Demo_3 categoryId={selectedFirstChildId} />
)}


<ImageCarousel autoPlay={true} interval={4000} />
<Footer />


    </div>
  );
};

export default Header1; 